(() => {
  function init(root) {
    if (root.dataset.eventsReady === 'true') return;
    root.dataset.eventsReady = 'true';
    const buttons = [...root.querySelectorAll('.kevents__filter')];
    const search = root.querySelector('[data-search]');
    const sort = root.querySelector('[data-sort]');
    const grid = root.querySelector('[data-grid]');
    const featured = root.querySelector('.kevents__featured-wrap');
    const cards = [...grid.querySelectorAll('.kevents__card')];
    const empty = root.querySelector('[data-empty]');
    const count = root.querySelector('[data-count]');
    let category = 'all';

    const normalize = value => (value || '').toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    function update() {
      const query = normalize(search.value.trim());
      const matches = item => (category === 'all' || item.dataset.category === category) && (!query || normalize(item.textContent).includes(query));
      const featuredVisible = featured && matches(featured);
      if (featured) featured.hidden = !featuredVisible;
      let visible = featuredVisible ? 1 : 0;
      cards.forEach(card => {
        card.hidden = !matches(card);
        if (!card.hidden) visible++;
      });
      const order = sort.value;
      cards.sort((a, b) => {
        if (order === 'az') return a.dataset.title.localeCompare(b.dataset.title, 'it');
        if (order === 'newest' || order === 'oldest') {
          const aDate = a.dataset.date || (order === 'newest' ? '0000' : '9999');
          const bDate = b.dataset.date || (order === 'newest' ? '0000' : '9999');
          return order === 'newest' ? bDate.localeCompare(aDate) : aDate.localeCompare(bDate);
        }
        return Number(a.dataset.original) - Number(b.dataset.original);
      }).forEach(card => grid.append(card));
      empty.hidden = visible > 0;
      count.textContent = visible === 1 ? '1 contenuto' : visible + ' contenuti';
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      category = button.dataset.category;
      buttons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      update();
    }));
    search.addEventListener('input', update);
    sort.addEventListener('change', update);
    update();
  }
  function initAll(scope = document) {
    scope.querySelectorAll('.kevents').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
